import React, { useState, useEffect } from "react";
import { Select, DatePicker, Input, Button, Form, Badge, InputNumber } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import Filterloader from "../../../../components/loaderFilter";
import * as zoneActions from "../../../../redux/actions/zone.actions";
import * as actionPage from "../../../../redux/actions/pickerPakerPage.actions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
// import moment from "moment";
// const { RangePicker } = DatePicker;

const idOption = [
  {value: 'keyword',label: 'All'},
  {value: 'id',label: 'P/P ID'},
  // {value: 'all',label: 'All'},
  // {value: 'display_id',label: 'P/P ID'},
]

const statusOption = [
  // {value: 'available',label: 'Active'},
  {value: 'available',label: 'Available'},
  {value: 'pending',label: 'Pending'},
  {value: 'blocked',label: 'Blocked'},
  {value: 'suspended',label: 'Suspended'},
  {value: 'approved',label: 'Approved'},
]

const PickerPackerFilters = (props) => {
  const [postDataZone, setPostDataZone] = useState(null);
  const [postDataZoneIdsAll, setPostDataZoneIdsAll] = useState([]);
  const [limit, setLimit] = useState(null);

  const [form] = Form.useForm();

  useEffect(() => {
    postLists()
  }, []);

  const postLists = async() => {
    await props.zoneActions.getZoneListAction();
  }

  useEffect(() => {
    if (props.zoneData) {
      const zoneData = [];
      const zoneDataAll = [];
      props.zoneData.map((item) => {
        zoneData.push({value: item?.id, label: item?.zoneName})
        zoneDataAll.push(item?.id);
      });
      setPostDataZoneIdsAll(zoneDataAll);
      setPostDataZone([{value: 'all', label: '---SELECT ALL---'}, ...zoneData]);
    }
  }, [props.zoneData]);

  const onChangeHandelZone = async (value) => {
    if(value?.includes("all")){
      form.setFieldsValue({
        ...props.pageFilter,
        zones: postDataZoneIdsAll,
      });
    }
  }

  useEffect(() => {
    if (props.pageFilter){
      setLimit(props.pageFilter)
      form.setFieldsValue(props.pageFilter || null);
    }
  }, [props.pageFilter])

  const filterChange = async(value) => {
    const newData = {
      ...props.pageFilter,
      ...value,
      page: 1,
      keyword: value?.searchOption === 'keyword' ? value?.keyword : null,
      id: value?.searchOption === 'id' ? value?.id : null,
    };
    await props.actionPage.filterAction(newData);
  }

  const resetSearch = async (e) => {
    const newData = {
      page: 1,
      limit: 10,
      searchOption: 'keyword',
      // date: [moment(), moment()],
    };
    form.resetFields();
    await props.actionPage.filterAction(newData);
  };

  const limitChange = (value, name) => {
    setLimit((limit)=>({
      ...limit,
      [name]: value,
    }))
  }
  
  return props?.pageLoading ? <Filterloader /> : (
    <Form form={form} className="fliters_form no-label" disabled={props?.pageLoading} onFinish={filterChange} layout="vertical" initialValues={{ modifier: 'public', }}>
      <Badge
        count={props?.pagePagination?.totalRidersCount? "Total: " + props?.pagePagination?.totalRidersCount: "Total: " + 0}
        style={{backgroundColor: "transparent",color: "#282828",boxShadow: "0 0 0 1px #282828",}}
      />
      <Badge
        count={props?.pagePagination?.totalActiveRiders? "Active: " + props?.pagePagination?.totalActiveRiders: "Active: " + 0}
        style={{backgroundColor: "#52c41a",}}
      />
      <Form.Item name={["searchOption"]} label={'Status'}>
        <Select
          showSearch
          // allowClear
          // mode="multiple"
          optionFilterProp="children"
          filterOption={(input, option)=>(option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
          options={idOption}
          style={{ minWidth: 160}}
          placeholder="Status"
          onChange={(val)=>limitChange(val, 'searchOption')}
        />
      </Form.Item>
      <Form.Item name={["status"]} label={'Status'}>
        <Select
          showSearch
          allowClear
          // mode="multiple"
          optionFilterProp="children"
          filterOption={(input, option)=>(option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
          options={statusOption}
          style={{ minWidth: 160}}
          placeholder="Status"
        />
      </Form.Item>
      <Form.Item name={[limit?.searchOption]} label={'Key word'}>
        {limit?.searchOption === 'id' ? <InputNumber style={{width: 200,}}/> : <Input style={{width: 200,}} />}
      </Form.Item>
      <Form.Item name={["zones"]} label='Zone'>
        <Select
          showSearch
          allowClear
          mode="multiple"
          optionFilterProp="children"
          filterOption={(input, option)=>(option?.label ?? '').toLowerCase().includes(input.toLowerCase())}
          options={postDataZone}
          onChange={onChangeHandelZone}
          style={{ minWidth: 300}}
          placeholder="Zone"
        />
      </Form.Item>
      <Button htmlType="submit" loading={props?.pageLoading}>Search <SearchOutlined /></Button>
      <Button loading={props?.pageLoading} onClick={()=>resetSearch()}>Reset</Button>
    </Form>
  );
};

const mapStateToProps = (state) => {
  return {
    zoneData: state.ZoneReducer.zoneData,
    pageLoading: state.PickerPakerPageReducer?.initialLoading,
    pageFilter: state.PickerPakerPageReducer?.initialFilter,
    pagePagination: state.PickerPakerPageReducer?.initialPagination,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    zoneActions: bindActionCreators(zoneActions, dispatch),
    actionPage: bindActionCreators(actionPage, dispatch),
  };
};

export default connect(mapStateToProps,mapDispatchToProps)(PickerPackerFilters);